export const consentPluginConfig = {
  guiOptions: {
    consentModal: {
      layout: 'cloud inline',
      position: 'bottom right',
      flipButtons: false,
      equalWeightButtons: false,
    },
    preferencesModal: {
      layout: 'box',
      flipButtons: false,
      equalWeightButtons: true,
    },
  },
  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    analytics: {
      enabled: true,
      autoClear: {
        cookies: [
          {
            name: /^(_ga|_gid|_hj.*|_pk.*|_fbp|_fr)/,
          },
        ],
      },
      services: {
        'Google Analytics': {
          label: 'Google Analytics',
          cookies: [
            {
              name: /^_ga|_gid/,
            },
          ],
        },
        Hotjar: {
          label: 'Hotjar',
          cookies: [
            {
              name: /^_hj.*$/,
            },
          ],
        },
        Matomo: {
          label: 'Matomo',
          cookies: [
            {
              name: /^_pk.*$/,
            },
          ],
        },
        Facebook: {
          label: 'Facebook',
          cookies: [
            {
              name: /^fbq.*$/,
            },
          ],
        },
      },
    },
    marketing: {
      enabled: true,
    },
  },
  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          description: 'We are using cookies. <a style="text-decoration: underline; font-weight: normal;" href="/cookie-policy" target="_blank" rel="noopener noreferrer">Our policy</a>.',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject',
          showPreferencesBtn: 'Settings',
        },
        preferencesModal: {
          title: 'Cookie preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Save preferences',
          closeIconLabel: 'Close',
          sections: [
            {
              title: 'Cookie usage',
              description: 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience ...',
            },
            {
              title: 'Strictly necessary cookies',
              description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
              linkedCategory: 'necessary',
              cookieTable: {
                headers: {
                  name: 'Name',
                  domain: 'Service',
                  description: 'Description',
                  expiration: 'Expiration',
                },
                body: [
                  {
                    name: 'Browser Language',
                    domain: 'Omnislots',
                    description: 'Cookie set by Omnislots to store the user\'s preferred language setting',
                    expiration: 'Persistent storage',
                  },
                  {
                    name: 'Session',
                    domain: 'Omnislots',
                    description: 'Cookie set by Omnislots to store user session data and authentication tokens for logged-in users',
                    expiration: 'Session-based, expires after inactivity timeout',
                  },
                  {
                    name: 'EGASS',
                    domain: 'https://omnislots.com',
                    description:
                            'Cookie set by <a href="https://omnislots.com/" target="_blank" rel="noopener noreferrer">EGASS</a> to handle affiliate tracking and conversion attribution.',
                    expiration: 'Typically expires after 30 days.',
                  },
                ],
              },
            },
            {
              title: 'Performance and Analytics cookies',
              description: 'These cookies allow the website to remember the choices you have made in the past',
              linkedCategory: 'analytics',
              cookieTable: {
                headers: {
                  name: 'Name',
                  domain: 'Service',
                  description: 'Description',
                  expiration: 'Expiration',
                },
                body: [
                  {
                    name: '_ga',
                    domain: 'Google Analytics',
                    description: 'Cookie set by <a href="#das">Google Analytics</a>',
                    expiration: 'Expires after 12 days',
                  },
                  {
                    name: '_gid',
                    domain: 'Google Analytics',
                    description: 'Cookie set by <a href="#das">Google Analytics</a>',
                    expiration: 'Session',
                  },
                  {
                    name: '_pk.*',
                    domain: 'Matomo',
                    description: 'Cookie set by <a href="https://matomo.org/" target="_blank" rel="noopener noreferrer">Matomo</a> for website analytics and performance tracking.',
                    expiration: 'Typically expires after 13 months, depending on configuration.',
                  },
                  {
                    name: '_hj.*',
                    domain: 'Hotjar',
                    description: 'Cookie set by <a href="https://hotjar.com/" target="_blank" rel="noopener noreferrer">Hotjar</a> for website analytics and performance tracking. These cookies allow the Hotjar Tracking Code to function correctly. Apart from cookies, the Hotjar Tracking Code uses local and session storage as well.',
                    expiration: 'Typically expires after 365 days.',
                  },
                ],
              },
            },
            {
              title: 'Marketing cookies',
              description: 'Used to track visitors across websites for advertising purposes',
              linkedCategory: 'marketing',
              cookieTable: {
                headers: {
                  name: 'Name',
                  domain: 'Service',
                  description: 'Description',
                  expiration: 'Expiration',
                },
                body: [
                  {
                    name: 'Admaximum',
                    domain: 'https://admaxium.com',
                    description: 'Cookie set by <a href="https://admaximum.com/" target="_blank" rel="noopener noreferrer">Admaximum</a> to serve and track performance-based marketing ads.',
                    expiration: 'Typically expires at the end of the session or up to 30 days, depending on tracking needs.',
                  },
                  {
                    name: 'Facebook Pixel',
                    domain: 'Facebook',
                    description: 'Cookie set by <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer">Facebook</a> to serve and track performance-based marketing ads.',
                    expiration: 'Typically expires at the end of the session or up to 30 days, depending on tracking needs.',
                  },
                ],
              },
            },
            {
              title: 'More information',
              description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/email">contact us</a>.',
            },
          ],
        },
      },
    },
  },
};

export default consentPluginConfig;
